










































































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'PrivacyPolicyPageForWoMens'
})
export default class PrivacyPolicyPageForWoMens extends Vue {

}
